export const availablePlatforms = [
  {
    id: "youtube",
    name: "YouTube",
    icon: "fab fa-youtube",
    color: "#FF0000",
    logo: "https://upload.wikimedia.org/wikipedia/commons/b/b8/YouTube_Logo_2017.svg",
  },
  {
    id: "facebook",
    name: "Facebook",
    icon: "fab fa-facebook",
    color: "#1877F2",
    logo: "https://upload.wikimedia.org/wikipedia/commons/5/51/Facebook_f_logo_%282019%29.svg",
  },
  {
    id: "instagram",
    name: "Instagram",
    icon: "fab fa-instagram",
    color: "#E4405F",
    logo: "https://upload.wikimedia.org/wikipedia/commons/a/a5/Instagram_icon.png",
  },
  {
    id: "tiktok",
    name: "TikTok",
    icon: "fab fa-tiktok",
    color: "#000000",
    logo: "https://upload.wikimedia.org/wikipedia/en/a/a9/TikTok_logo.svg",
  },
  {
    id: "twitch",
    name: "Twitch",
    icon: "fab fa-twitch",
    color: "#9147ff",
    logo: "https://upload.wikimedia.org/wikipedia/commons/2/26/Twitch_logo.svg",
  },
  {
    id: "twitter",
    name: "Twitter (X)",
    icon: "fab fa-twitter",
    color: "#1DA1F2",
    logo: "https://upload.wikimedia.org/wikipedia/commons/6/6f/Logo_of_Twitter.svg",
  },
];